module.exports = __webpack_public_path__ + "img/11_40.b90a148d.png";